import { CardsGridComplexProps } from './types';
import CardsStackedItemImageFullBleedVariant from '@/components/CardsStacked/CardsStackedItemImageFullBleedVariant';
import { getColorway, getYMargins, cn } from 'utils/styles';
import { CardLayout } from 'types/constants';
import { liveUpdateAttrs } from 'libs/contentful/utils';

export default function CardsGridComplex({
  sys,
  sectionName,
  cards,
  color,
  margins,
  cardLayout,
}: CardsGridComplexProps) {
  const items = cards?.items;

  return (
    <section
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className={`${getColorway(color)} ${getYMargins(margins)}`}
      {...liveUpdateAttrs(sys?.id, 'cards')}>
      <div className="content-wrapper">
        <div
          className={cn(
            'flex flex-row  gap-6',
            cardLayout === CardLayout.TwoOnTop ? 'flex-wrap-reverse' : 'flex-wrap',
          )}>
          {items.map((item, i) => (
            <CardsStackedItemImageFullBleedVariant
              sys={sys}
              key={i}
              sectionName={item.sectionName}
              desktopMedia={item.desktopImage}
              mobileMedia={item.mobileImage}
              eyebrow={item.eyebrow}
              eyebrowRte={item.eyebrowRte}
              headline={item.headline}
              shortDescription={item.copy}
              cta={item.cta}
              color={item.color}
              topRightBadge={item.topRightBadge}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
